import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
export const BU_CODE_LOCALESTORAGE = 'buCode';
export const useBuCode = () => {
    const { buCode: code1, code: code2 } = useParams();
    const { search } = useLocation();
    const buCode = React.useMemo(() => {
        if (code1) {
            const value = decodeURIComponent(code1).toUpperCase();
            localStorage.removeItem(BU_CODE_LOCALESTORAGE);
            localStorage.setItem(BU_CODE_LOCALESTORAGE, value);
            return value;
        }
        else if (code2) {
            const value = decodeURIComponent(code2).toUpperCase();
            localStorage.removeItem(BU_CODE_LOCALESTORAGE);
            localStorage.setItem(BU_CODE_LOCALESTORAGE, value);
            return value;
        }
        else {
            const params = new URLSearchParams(search);
            const buCodeParam = params.get('bu');
            if (buCodeParam) {
                const value = decodeURIComponent(buCodeParam).toUpperCase();
                localStorage.removeItem(BU_CODE_LOCALESTORAGE);
                localStorage.setItem(BU_CODE_LOCALESTORAGE, value);
                return value;
            }
            else {
                const storageBU = localStorage.getItem(BU_CODE_LOCALESTORAGE);
                if (storageBU) {
                    const value = storageBU.toUpperCase();
                    localStorage.removeItem(BU_CODE_LOCALESTORAGE);
                    localStorage.setItem(BU_CODE_LOCALESTORAGE, value);
                    return value;
                }
            }
        }
        return 'SHARE';
    }, [code1, code2, search]);
    return buCode;
};
